import React from 'react';
import * as S from './styled';
import Backdrop from '../Backdrop';

const Dropdown = ({
  open,
  small = false,
  children,
  dropup,
  onClose,
  ...rest
}) => {
  if (!open) {
    return null;
  }
  return (
    <>
      <Backdrop onClick={onClose} />
      <S.Dropdown className={dropup && 'dropup'} small={small} {...rest}>
        {children}
      </S.Dropdown>
    </>
  );
};

export default Dropdown;
